import { BaseIcon, ImageResource } from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";

const PlaceholderIcon = styled(BaseIcon)`
	width: 100px;
	height: 100px;
	color: initial;
`;

const Wrapper = styled.div`
	aspect-ratio: 16/9;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${({ theme }) => theme.colors.palette.grey[20]};
`;

const Image = styled.img`
	width: 100%;
	height: 100%;
`;

interface Props {
	image: ImageResource | null;
}
export const HotelImage: FC<Props> = ({ image }) => {
	return <Wrapper>{image ? <Image src={image.url} /> : <PlaceholderIcon src="/icons/apartment.svg" />}</Wrapper>;
};
